function createSourceBookingId() {
  const random = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID().replace(/-/g, '')
    : `${Date.now()}${Math.random().toString(16).slice(2)}`;
  return `web_${random.slice(0, 20)}`;
}

export async function createWebsiteBooking(payload) {
  const response = await fetch('/.netlify/functions/create-website-booking', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...payload,
      businessId: 'easydroptaxi',
      source: 'website',
    }),
  });

  let data = {};
  try {
    data = await response.json();
  } catch (error) {
    data = {};
  }

  if (!response.ok || !data.success || !data.referenceId) {
    const error = new Error(data.error || 'Booking could not be saved. Please try again.');
    error.statusCode = response.status;
    throw error;
  }

  return data;
}

export { createSourceBookingId };
